import { toast } from "react-toastify";
import Button from "../../components/ui/button/Button";
import { useModal } from "../../hooks/useModal"
import { Modal } from "../ui/modal";
import PasswordInput from "../form/form-elements/PasswordInput";
import Label from "../form/Label";
import { useForm } from "react-hook-form";
import useDeleteUser from "../../hooks/User/useDeleteUser";
import { clearStoredToken } from "../../apollo/client";
import { clearConsent } from "../../lib/consent/consent.utils";

import type { DeleteUserVariables, User } from "../../types/userTypes";

type Props = {
  user: User;
};

const DeleteUserCard = ({ user }:Props) => {
  const { isOpen, openModal, closeModal } = useModal();
  const {
    register,
    watch,
  } = useForm<DeleteUserVariables>({
    defaultValues: {
      id: user.id!
    }
  });

  const { deleteUser } = useDeleteUser({
    onCompleted: (deactivatedUser) => {
      if (deactivatedUser) {
        closeModal()
        clearStoredToken();
        clearConsent();
        return window.location.href = '/';
      }
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }
  });

  return (
    <div className="p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6">
      <h4 className="text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-6">
        Delete Account
      </h4>
      <div>
        <Button 
          size="md" 
          variant="delete"
          onClick={openModal}
        >
          Delete Account
        </Button>
      </div>
      <Modal 
        isOpen={isOpen}
        onClose={closeModal}
        showCloseButton
        className="max-w-[700px] max-h-[95vh] overflow-x-auto custom-scrollbar">
          <>
            <p className="m-10 text-base text-center font-medium text-gray-800 dark:text-white/90">
              <span>You want to delete this account?</span>
              <br />
              <span>Please, enter password before delete account.</span>
            </p>
            <div className="flex flex-col">
              <div className="p-10">
                <Label htmlFor="password">Password</Label>
                <PasswordInput
                  placeholder="Enter password"
                  register={register("password", {
                    required: "Password is required"
                  })}
                />
              </div>
            </div>  
            <div className='mb-10 flex justify-evenly'>
              <Button 
                size="md" 
                variant="outline"
                onClick={async () => {
                  await deleteUser({
                    id: user.id!,
                    password: watch("password")
                  });
                }}
              >
                Yes
              </Button>
              <Button 
                size="md" 
                variant="primary"
                onClick={closeModal}
              >
                Cancel
              </Button>
            </div>
          </>
      </Modal>
    </div>  
  );
};

export default DeleteUserCard;
